module.exports = __webpack_public_path__ + "img/icon_compass.675fd319.png";